/** Gerätekennung für die Kopplung: gleich bei jeder Wiederholung (verlorene Antwort), nie ein Fingerabdruck des Geräts. */
const DEVICE_ID_KEY = 'barso.deviceId';

/** Kennung dieses Geräts für die Kopplung; ohne Speicher wird bei jedem Aufruf eine neue erzeugt. */
export function clientDeviceId(): string {
  try {
    const existing = window.localStorage.getItem(DEVICE_ID_KEY);
    if (existing !== null && /^[0-9a-f-]{36}$/i.test(existing)) return existing;
    const created = crypto.randomUUID();
    window.localStorage.setItem(DEVICE_ID_KEY, created);
    return created;
  } catch {
    return crypto.randomUUID();
  }
}
